import {
  bsc as baseBSC,
  base as baseBase,
  mainnet as baseMainnet,
  bscTestnet as baseTBSC,
  unichainSepolia as baseUni,
} from "viem/chains";

import { IChain, ChainSymbols, ChainIds } from "./types";
import { networkEth } from "../networks";
import { BaseLogo, BSCLogo, EthLogo, UniLogo } from "based-assets";

export const chainEth: IChain = {
  ...baseMainnet,
  id: ChainIds.eth,
  symbol: ChainSymbols.eth,
  logo: EthLogo,
  network: networkEth,
  blockExplorers: {
    ...baseMainnet.blockExplorers,
    default: {
      ...baseMainnet.blockExplorers.default,
      hash: "https://etherscan.io/tx/{{addr}}",
      address: "https://etherscan.io/address/{{addr}}",
    },
  },
};

export const chainBSC: IChain = {
  ...baseBSC,
  id: ChainIds.bsc,
  symbol: ChainSymbols.bsc,
  logo: BSCLogo,
  network: networkEth,
  rpcUrls: {
    default: {
      http: [
        baseBSC.rpcUrls.default.http[0],
        "https://bsc.blockpi.network/v1/rpc/32cdfa234a4a17abbb8e3f23bc6410a9b7d47cb3",
      ],
    },
  },
  blockExplorers: {
    ...baseBSC.blockExplorers,
    default: {
      ...baseBSC.blockExplorers.default,
      hash: "https://bscscan.com/tx/{{addr}}",
      address: "https://bscscan.com/address/{{addr}}",
    },
  },
};

export const chainBSCTestnet: IChain = {
  ...baseTBSC,
  id: ChainIds.tbsc,
  symbol: ChainSymbols.tbsc,
  logo: BSCLogo,
  network: networkEth,
  rpcUrls: {
    default: {
      http: [
        "https://bsc-testnet-rpc.publicnode.com",
        ...baseTBSC.rpcUrls.default.http,
      ],
      webSocket: [
        "wss://bsc-testnet-rpc.publicnode.com",
        "wss://bsc-testnet.blockpi.network/v1/ws/cd61e00aed93674ae0d608f823e2c2d05a52752d",
      ],
    },
  },
  blockExplorers: {
    ...baseTBSC.blockExplorers,
    default: {
      ...baseTBSC.blockExplorers.default,
      hash: "https://testnet.bscscan.com/tx/{{addr}}",
      address: "https://testnet.bscscan.com/address/{{addr}}",
    },
  },
};

export const chainUni: IChain = {
  ...baseUni,
  id: ChainIds.uni,
  symbol: ChainSymbols.uni,
  logo: UniLogo,
  network: networkEth,
  blockExplorers: {
    ...baseUni.blockExplorers,
    default: {
      ...baseUni.blockExplorers.default,
      hash: "https://explorer.unichain.io/tx/{{addr}}",
      address: "https://explorer.unichain.io/address/{{addr}}",
    },
  },
};

export const chainBase: IChain = {
  ...baseBase,
  id: ChainIds.base,
  symbol: ChainSymbols.base,
  logo: BaseLogo,
  network: networkEth,
  blockExplorers: {
    ...baseBase.blockExplorers,
    default: {
      ...baseBase.blockExplorers.default,
      hash: "https://basescan.org/tx/{{addr}}",
      address: "https://basescan.org/address/{{addr}}",
    },
  },
};
